$(document).on('shown.bs.collapse', '#interests .expandable-form', (event) => {
    let pageLocation = $(event.target).closest('form').offset().top - 150;
    $('html, body').animate({
        scrollTop: pageLocation
    }, 100);
});

